














































import { Vue, Component } from 'vue-property-decorator'
import Table, { Config, Pagination } from '@/views/enroll/components/Table.vue'
import ExamSelect from './components/ExamSelect.vue'
import { SpringExam, SpringExamUser } from '@/models/springexam/SpringExam'
import { getList, del, delAll } from '@/api/springexam/springexamuser'
import { Nilable } from '@/models/helpers/common'
import { notify, comfirm } from '@/utils/notification'
import UserUploader from './components/UserUploader.vue'
import { downloadExcel } from '@/service/SpringExam/springExamUser'

@Component({
  components: { Table, ExamSelect, UserUploader }
})
export default class SpringExamUserManage extends Vue {
  InstantData: SpringExamUser[] = []
  InstantCount = 0
  form = {
    exam: null as Nilable<string>
  }
  loading = false
  showUpload = false
  selectedExam: SpringExam = {
    name: '',
    explain: '',
    examProjects: [],
    examUsers: []
  }
  selectedUser: SpringExamUser = {
    name: '',
    bmh: '',
    sfzh: '',
    major1: '',
    major2: '',
    selectExamTime1: '',
    selectSkill1: '',
    selectExamTime2: '',
    selectSkill2: ''
  }
  get Instantpagination(): Pagination {
    return {
      current: 1,
      pagesize: 10
    }
  }
  get InstantConfig(): Config {
    return {
      rowKey: 'id',
      total: this.InstantCount,
      selection: 'radio',
      maxHeight: 700,
      columns: [
        // { prop: 'id', label: 'ID', width: 80 },
        { prop: 'name', label: '学生姓名', width: 200, fixed: 'left' },
        {
          prop: 'bmh',
          label: '报名号'
        },
        {
          prop: 'sfzh',
          label: '身份证号'
        },
        {
          prop: 'major1',
          label: '报考专业1'
        },
        {
          prop: 'major2',
          label: '报考专业2'
        },
        {
          prop: 'selectExamTime1',
          label: '专业1所选考试时间'
        },
        {
          prop: 'selectExamTime2',
          label: '专业2所选考试时间'
        },
        {
          prop: 'selectSkill1',
          label: '专业1所选表演才艺'
        },
        {
          prop: 'selectSkill2',
          label: '专业2所选表演才艺'
        },
        {
          prop: 'option',
          label: '操作',
          type: {
            type: 'buttonGroup',
            group: [
              // {
              //   event: 'Edit',
              //   text: '编辑',
              //   right: '',
              //   buttonType: 'primary'
              //  },
              {
                event: 'Delete',
                text: '删除',
                right: '',
                buttonType: 'danger'
              }
            ],
            style: 'group',
            size: 'small'
          },
          width: 200,
          fixed: 'right'
        }
      ]
    }
  }
  UploadStd() {
    this.showUpload = true
  }
  DownLoadStd() {
    downloadExcel(this.form.exam!)
  }
  async CleanStd() {
    await comfirm(`确认清除当前考试所有学生么?`, { type: 'warning' })
    try {
      await delAll(this.form.exam!)
      notify('删除成功！')
      this.loadData(this.Instantpagination)
    } catch (e) {
      notify('删除失败！', e)
    }
    return
  }
  backUploadToTable() {
    this.showUpload = false
  }
  uploadsuccess() {
    this.loadData(this.Instantpagination)
    this.showUpload = false
  }
  handleExamChange(exam: SpringExam) {
    this.selectedExam = exam
    this.loadData(this.Instantpagination)
  }

  async loadData(pagination: Pagination) {
    try {
      this.loading = true
      let limit = pagination.pagesize
      let offset = pagination.pagesize * (pagination.current - 1)
      const { rows, total } = await getList(this.form.exam!, limit, offset)
      this.InstantCount = total
      this.InstantData = rows
    } catch (e) {
      notify('获取数据失败', e)
    }
    this.loading = false
    return this.InstantData
  }
  async onButtonClick($event: any) {
    switch ($event.event) {
      case 'Edit': {
        return
      }
      case 'Details': {
        return
      }

      case 'Delete': {
        this.selectedUser = $event.row
        await comfirm(`确认删除${$event.row.name}么?`, { type: 'warning' })
        try {
          await del(this.selectedUser.id as string, this.form.exam!)
          notify('删除成功！')
          this.loadData(this.Instantpagination)
        } catch (e) {
          notify('删除失败！', e)
        }
        return
      }
      default:
        break
    }
  }
}
